
import React from 'react';
import { Link } from 'react-router-dom';
import Lottie from 'react-lottie';

import 'bulma/css/bulma.css';
import arrow from '../../../../assets/lotties/UI/arrow';
import styles from './button.module.scss';

export const Button = (props) => {
  const { storyId } = props;

  const continueArrow = {
    loop: false,
    autoplay: true,
    animationData: arrow,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice"
    }
  };

  return (
    <div className={styles.continue}>
        <button className={styles.continueBtn}>
          <Link to={{
              pathname: `/story/${storyId}`, 
              state: {storyId: storyId}}}
          >
            <Lottie options={continueArrow} />
          </Link>
        </button>
    </div>
  );
};            
            
        